
import Driver from "../../../assets/outline/Driver.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DriverIcon({ className, dataTestid = "DriverIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Driver data-testid={dataTestid} className={classes} {...rest} />
  );
}
